function PipelineStage({ stage, status, isActive, onClick }) {
    const getStatusColor = () => {
        switch (status?.status) {
            case 'complete':
                return 'border-green-500 bg-green-50';
            case 'active':
                return 'border-blue-500 bg-blue-50 shadow-lg';
            case 'pending':
                return 'border-gray-300 bg-white';
            default:
                return 'border-gray-300 bg-white';
        }
    };

    const getStatusIcon = () => {
        switch (status?.status) {
            case 'complete':
                return '✅';
            case 'active':
                return '🔄';
            case 'pending':
                return '⏳';
            default:
                return '⏳';
        }
    };

    const getStatusText = () => {
        switch (status?.status) {
            case 'complete':
                return 'Complete';
            case 'active':
                return 'In Progress';
            case 'pending':
                return 'Pending';
            default:
                return 'Not Started';
        }
    };

    return (
        <button
            onClick={onClick}
            className={`w-full p-4 rounded-lg border-2 transition-all cursor-pointer hover:shadow-md ${
                getStatusColor()
            } ${isActive ? 'ring-2 ring-blue-400 ring-offset-2' : ''}`}
        >
            <div className="text-center space-y-2">
                {/* Stage Number */}
                <div className="text-2xl">{stage.number}</div>

                {/* Stage Name */}
                <div className="font-bold text-gray-900 text-sm">{stage.name}</div>

                {/* Status */}
                <div className="flex items-center justify-center gap-1 text-xs">
                    <span>{getStatusIcon()}</span>
                    <span className={`font-medium ${
                        status?.status === 'complete' ? 'text-green-700' :
                        status?.status === 'active' ? 'text-blue-700' :
                        'text-gray-600'
                    }`}>
                        {getStatusText()}
                    </span>
                </div>

                {/* Progress Bar (if active) */}
                {status?.status === 'active' && status?.progress !== undefined && (
                    <div className="w-full bg-gray-200 rounded-full h-1.5 mt-2">
                        <div
                            className="bg-blue-600 h-1.5 rounded-full transition-all duration-300"
                            style={{ width: `${status.progress}%` }}
                        />
                    </div>
                )}

                {/* Agent */}
                <div className="text-xs text-gray-600 pt-2 border-t border-gray-200">
                    {stage.agent}
                </div>

                {/* Description */}
                <div className="text-xs text-gray-500">
                    {stage.description}
                </div>
            </div>
        </button>
    );
}

export default PipelineStage;
